export default "__VITE_ASSET__BeImeKaw__"